import { actions } from "app/publicDictionaryValues";
import { IRouteParam } from "./types";

const needCheckStepActions = [actions.submit, actions.return, actions.revise, actions.approve];

const getNotSubmitRevisionInformation = (props: IRouteParam) => {
  const { currfileStepData, prevfileStepData } = props;

  const currentIds = new Set(currfileStepData.revisionFormInfo.attachmentFiles.map((f) => f.fileId));
  const prevIds = new Set(prevfileStepData.revisionFormInfo.attachmentFiles.map((f) => f.fileId));
  return {
    RevisionCategory: prevfileStepData.revisionFormInfo.revisionCategoryID !== currfileStepData.revisionFormInfo.revisionCategoryID,
    RequestDate: prevfileStepData.revisionFormInfo.requestDate !== currfileStepData.revisionFormInfo.requestDate,
    RequestFrom:
      prevfileStepData.revisionFormInfo.requestFromID !== currfileStepData.revisionFormInfo.requestFromID ||
      prevfileStepData.revisionFormInfo.requestFromDesc !== currfileStepData.revisionFormInfo.requestFromDesc,
    RevisionDescription: prevfileStepData.revisionFormInfo.revisionDescription !== currfileStepData.revisionFormInfo.revisionDescription,
    RevisionAttachment: currentIds.size !== prevIds.size || [...currentIds].some((id) => !prevIds.has(id)),
  };
};

export { getNotSubmitRevisionInformation, needCheckStepActions };
